"use strict";Object.defineProperty(exports, "__esModule", {value: true});



var _AVNURAH2cjs = require('./AVNURAH2.cjs');


var _STJK5WUWcjs = require('./STJK5WUW.cjs');


var _KEDCOTT4cjs = require('./KEDCOTT4.cjs');


var _6E4BBKC4cjs = require('./6E4BBKC4.cjs');


var _FH6HQ5JNcjs = require('./FH6HQ5JN.cjs');




var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');








var _3BSDKDKDcjs = require('./3BSDKDKD.cjs');

// src/select/select-list.tsx
var _events = require('@ariakit/core/utils/events');
var _misc = require('@ariakit/core/utils/misc');
var _react = require('react');
var _jsxruntime = require('react/jsx-runtime');
var TagName = "div";
var SelectListContext = _react.createContext.call(void 0, null);
var useSelectList = _PTOCUU2Dcjs.createHook.call(void 0, 
  function useSelectList2({
    store,
    resetOnEscape = true,
    hideOnEnter = true,
    focusOnMove = true,
    composite,
    alwaysVisible,
    ...props
  }) {
    const context = _AVNURAH2cjs.useSelectContext.call(void 0, );
    store = store || context;
    _misc.invariant.call(void 0, 
      store,
      process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component."
    );
    const id = _3BSDKDKDcjs.useId.call(void 0, props.id);
    const value = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "value");
    const multiSelectable = Array.isArray(value);
    const [defaultValue, setDefaultValue] = _react.useState.call(void 0, value);
    const mounted = _FH6HQ5JNcjs.useStoreState.call(void 0, store, "mounted");
    _react.useEffect.call(void 0, () => {
      if (mounted) return;
      setDefaultValue(value);
    }, [mounted, value]);
    resetOnEscape = resetOnEscape && !multiSelectable;
    const onKeyDownProp = props.onKeyDown;
    const resetOnEscapeProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, resetOnEscape);
    const hideOnEnterProp = _3BSDKDKDcjs.useBooleanEvent.call(void 0, hideOnEnter);
    const onKeyDown = _3BSDKDKDcjs.useEvent.call(void 0, (event) => {
      onKeyDownProp == null ? void 0 : onKeyDownProp(event);
      if (event.defaultPrevented) return;
      if (event.key === "Escape" && resetOnEscapeProp(event)) {
        store == null ? void 0 : store.setValue(defaultValue);
      }
      if (event.key === " " || event.key === "Enter") {
        if (_events.isSelfTarget.call(void 0, event) && hideOnEnterProp(event)) {
          event.preventDefault();
          store == null ? void 0 : store.hide();
        }
      }
    });
    const headingContext = _react.useContext.call(void 0, _AVNURAH2cjs.SelectHeadingContext);
    const headingState = _react.useState.call(void 0, );
    const [headingId, setHeadingId] = headingContext || headingState;
    const headingContextValue = _react.useMemo.call(void 0, 
      () => [headingId, setHeadingId],
      [headingId, setHeadingId]
    );
    const [childStore, setChildStore] = _react.useState.call(void 0, null);
    const setStore = _react.useContext.call(void 0, SelectListContext);
    _react.useEffect.call(void 0, () => {
      if (!setStore) return;
      setStore(store);
      return () => setStore(null);
    }, [setStore, store]);
    props = _3BSDKDKDcjs.useWrapElement.call(void 0, 
      props,
      (element2) => /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _AVNURAH2cjs.SelectScopedContextProvider, { value: store, children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, SelectListContext.Provider, { value: setChildStore, children: /* @__PURE__ */ _jsxruntime.jsx.call(void 0, _AVNURAH2cjs.SelectHeadingContext.Provider, { value: headingContextValue, children: element2 }) }) }),
      [store, headingContextValue]
    );
    const hasCombobox = !!store.combobox;
    composite = composite != null ? composite : !hasCombobox && childStore !== store;
    const [element, setElement] = _3BSDKDKDcjs.useTransactionState.call(void 0, 
      composite ? store.setListElement : null
    );
    const role = _3BSDKDKDcjs.useAttribute.call(void 0, element, "role", props.role);
    const isCompositeRole = role === "listbox" || role === "menu" || role === "tree" || role === "grid";
    const ariaMultiSelectable = composite || isCompositeRole ? multiSelectable || void 0 : void 0;
    const hidden = _KEDCOTT4cjs.isHidden.call(void 0, mounted, props.hidden, alwaysVisible);
    const style = hidden ? { ...props.style, display: "none" } : props.style;
    if (composite) {
      props = {
        role: "listbox",
        "aria-multiselectable": ariaMultiSelectable,
        ...props
      };
    }
    const labelId = _FH6HQ5JNcjs.useStoreState.call(void 0, 
      store,
      (state) => {
        var _a;
        return headingId || ((_a = state.labelElement) == null ? void 0 : _a.id);
      }
    );
    props = {
      "aria-labelledby": props["aria-label"] != null ? void 0 : labelId,
      hidden,
      ...props,
      id,
      ref: _3BSDKDKDcjs.useMergeRefs.call(void 0, setElement, props.ref),
      style,
      onKeyDown
    };
    props = _6E4BBKC4cjs.useComposite.call(void 0, { store, ...props, composite });
    props = _STJK5WUWcjs.useCompositeTypeahead.call(void 0, { store, typeahead: !hasCombobox, ...props });
    return props;
  }
);
var SelectList = _PTOCUU2Dcjs.forwardRef.call(void 0, function SelectList2(props) {
  const htmlProps = useSelectList(props);
  return _PTOCUU2Dcjs.createElement.call(void 0, TagName, htmlProps);
});




exports.useSelectList = useSelectList; exports.SelectList = SelectList;
